var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.87,21.388H41.279c-1.104,0-2,0.896-2,2v36.633c0,1.104,0.896,2,2,2H67.87c1.104,0,2-0.896,2-2V23.388 C69.87,22.283,68.975,21.388,67.87,21.388z M65.87,58.021H43.279V25.388H65.87V58.021z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.598,32.807h15.954c1.104,0,2-0.896,2-2s-0.896-2-2-2H46.598c-1.104,0-2,0.896-2,2S45.494,32.807,46.598,32.807z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.598,40.226h15.954c1.104,0,2-0.896,2-2s-0.896-2-2-2H46.598c-1.104,0-2,0.896-2,2S45.494,40.226,46.598,40.226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.598,47.645h7.977c1.104,0,2-0.896,2-2s-0.896-2-2-2h-7.977c-1.104,0-2,0.896-2,2S45.494,47.645,46.598,47.645z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.226,64.247H36.635V29.614c0-1.104-0.896-2-2-2s-2,0.896-2,2v36.633c0,1.104,0.896,2,2,2h26.591c1.104,0,2-0.896,2-2 S62.33,64.247,61.226,64.247z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.721,70.612H30.129V35.979c0-1.104-0.896-2-2-2s-2,0.896-2,2v36.633c0,1.104,0.896,2,2,2h26.591c1.104,0,2-0.896,2-2 S55.825,70.612,54.721,70.612z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersion);
export default __webpack_public_path__ + "static/media/version.e832228c02e869fcfe41e64aa963fa18.svg";
export { ForwardRef as ReactComponent };